import { render, staticRenderFns } from "./MyBusiness.vue?vue&type=template&id=52dacd3a&"
import script from "./MyBusiness.vue?vue&type=script&lang=js&"
export * from "./MyBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports